/* CADS (10-oct-2026). Cuenta regresiva <cads-reloj> y vigencia de elementos con data-cads-desde / data-cads-hasta.
   La pagina puede venir de cache: lo que el servidor dejo visible se vuelve a revisar en el navegador cada minuto. */
(() => {
  if (window.cadsReloj) return;
  window.cadsReloj = true;

  const ms = (s) => {
    const t = Date.parse(s || '');
    return Number.isNaN(t) ? null : t;
  };
  const dos = (n) => String(n).padStart(2, '0');

  function vigencia() {
    const ahora = Date.now();
    document.querySelectorAll('[data-cads-desde], [data-cads-hasta]').forEach((el) => {
      const desde = ms(el.dataset.cadsDesde);
      const hasta = ms(el.dataset.cadsHasta);
      const fuera = (desde !== null && ahora < desde) || (hasta !== null && ahora >= hasta);
      el.classList.toggle('cads-fuera', fuera);
    });
    // Los navegadores frenan los temporizadores en pestanas ocultas: cada revision tambien actualiza los relojes
    document.querySelectorAll('cads-reloj').forEach((r) => {
      if (typeof r.tick === 'function' && r.fin) r.tick();
    });
    document.querySelectorAll('[data-cads-vacio]').forEach((caja) => {
      const quedan = caja.querySelectorAll('[data-cads-item]:not(.cads-fuera)').length;
      caja.classList.toggle('cads-sin-items', quedan === 0);
    });
  }

  class CadsReloj extends HTMLElement {
    connectedCallback() {
      this.fin = ms(this.dataset.fin);
      if (this.fin === null) return;
      this.d = this.querySelector('.js-d');
      this.h = this.querySelector('.js-h');
      this.m = this.querySelector('.js-m');
      this.s = this.querySelector('.js-s');
      this.uDias = this.querySelector('.cads-reloj__u--d');
      this.tick();
      this.timer = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    tick() {
      if (this.terminado) return;
      let s = Math.floor((this.fin - Date.now()) / 1000);
      if (s <= 0) {
        this.terminado = true;
        window.clearInterval(this.timer);
        this.terminar();
        return;
      }
      const d = Math.floor(s / 86400);
      s -= d * 86400;
      const h = Math.floor(s / 3600);
      s -= h * 3600;
      const m = Math.floor(s / 60);
      s -= m * 60;
      if (this.d) this.d.textContent = d;
      if (this.uDias) this.uDias.hidden = d === 0;
      if (this.h) this.h.textContent = dos(h);
      if (this.m) this.m.textContent = dos(m);
      if (this.s) this.s.textContent = dos(s);
      this.classList.add('is-listo');
    }

    terminar() {
      if (this.dataset.alTerminar === 'texto') {
        const activo = this.querySelector('.cads-reloj__activo');
        const final = this.querySelector('.cads-reloj__final');
        if (activo) activo.hidden = true;
        if (final) final.hidden = false;
        if (!final) this.hidden = true;
      } else {
        const caja = this.closest('[data-cads-contenedor]') || this;
        caja.classList.add('cads-fuera');
        vigencia();
      }
    }
  }

  if (!customElements.get('cads-reloj')) customElements.define('cads-reloj', CadsReloj);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vigencia);
  } else {
    vigencia();
  }
  window.setInterval(vigencia, 60000);
  document.addEventListener('shopify:section:load', vigencia);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) vigencia();
  });
})();
